import React, { useState, useEffect, useRef } from "react";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import "./Payments.css";
import { useTranslation } from "react-i18next";

// components imports
import ApprovedPaymentList from "./Components/ApprovedPaymentList/ApprovedPaymentList";
import PendingPaymentList from "./Components/PendingPaymentList/PendingPaymentList";
import CardManagement from "./Components/CardManagement/CardManagement";
import Invoices from "./Components/Invoices/Invoices";
import Taxes from "./Components/Taxes/Taxes";
import Settings from "./Ltl/Settings/Settings";

// apis imports
import { removeUnderscoresAndCapitalize } from "../../../../../helpers/helpers";
// library imports

import { initialPaymentTab } from "../../../../../data/permissionsArray";
import { limitsTabsByPermission } from "../../../../../helpers/storeAccess";
import { useSelector } from "react-redux";
import LtlApprovedPaymentList from "./Ltl/ApprovedPaymentList/ApprovedPaymentList";
import LtlPendingPaymentList from "./Ltl/PendingPaymentList/PendingPaymentList";
import LtlInvoices from "./Ltl/Invoices/Invoices";
import TabsComponent from "../../../../../Components/Common/TabsComponent";
import ReferralTransactions from "./Referral/ReferralTransactions";
import ReferralsManager from "../Settings/Components/ManageReferrals/ReferralsManager";

const Payments = () => {
  const { t } = useTranslation("finances");
  const [tab, setTab] = useState(0);
  const [mainTab, setMainTab] = useState("shipper");
  const [tabPermissions, setTabPermissions] = useState(initialPaymentTab);

  const user = useSelector((state) => state.user);
  const setSnack = useSnackBar();

  useEffect(() => {
    if (limitsTabsByPermission(user)) {
      let validPermissions = initialPaymentTab.filter((t) =>
        user?.mergedPermissions?.includes(t.name),
      );
      if (validPermissions?.length > 0) {
        setTab(validPermissions[0]?.value);
      } else {
        // setTab("nothing");
        setTab(0);
      }
      setTabPermissions(validPermissions);
    } else {
      setTab(0);
    }
  }, []);

  // Referrals belong to the Shipper parent account only. The backend rejects
  // other roles but not helpers (they share the parent's role), so helpers
  // are kept out here.
  const isShipperOwner = user?.role === "Shipper" && !user?.parent_id;

  const handleMainTabChange = (event, newValue) => {
    setMainTab(newValue);
    setTab(0);
  };
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >

      <TabsComponent
        items={[
          {
            label: t("tabs.shipper"),
            value: "shipper",
          },
          { label: "3PL", value: "ltl" },
          ...(isShipperOwner ? [{ label: t("tabs.referral"), value: "referral" }] : []),
        ]}
        tab={mainTab}
        handleTabChange={handleMainTabChange}
        separator
      />
      {mainTab === "shipper" && (
        <>
          {" "}
          <TabsComponent
            items={[
              { label: t("tabs.approved"), value: 0 },
              { label: t("tabs.pending"), value: 1 },
              {
                label: t("tabs.cardManagement"),
                value: 2,
              },
              { label: t("tabs.invoices"), value: 3 },
              { label: t("tabs.taxes"), value: 4 },
            ]}
            tab={tab}
            handleTabChange={handleTabChange}
          />
          {tab === 0 && (
            <ApprovedPaymentList setSnack={setSnack} />
          )}
          {tab === 1 && (
            <PendingPaymentList setSnack={setSnack} />
          )}
          {tab === 2 && <CardManagement setSnack={setSnack} />}
          {tab === 3 && <Invoices setSnack={setSnack} />}
          {tab === 4 && <Taxes setSnack={setSnack} />}
        </>
      )}
      {mainTab === "ltl" && (
        <>
          {" "}
          <TabsComponent
            items={[
              { label: t("tabs.approved"), value: 0 },
              { label: t("tabs.pending"), value: 1 },
              { label: t("tabs.invoices"), value: 2 },
              ...(user.role === "warehouseUser"
                ? [
                    {
                      label: t("tabs.settings"),
                      value: 3,
                    },
                  ]
                : []),
            ]}
            tab={tab}
            handleTabChange={handleTabChange}
          />
          {tab === 0 && (
            <LtlApprovedPaymentList setSnack={setSnack} />
          )}
          {tab === 1 && (
            <LtlPendingPaymentList setSnack={setSnack} />
          )}
          {tab === 2 && <LtlInvoices setSnack={setSnack} />}
          {tab === 3 && <Settings setSnack={setSnack} />}
        </>
      )}
      {mainTab === "referral" && isShipperOwner && (
        <>
          <TabsComponent
            items={[
              { label: t("tabs.transactions"), value: 0 },
              { label: t("tabs.settings"), value: 1 },
            ]}
            tab={tab}
            handleTabChange={handleTabChange}
          />
          <div className="pt-2">
            {tab === 0 && <ReferralTransactions setSnack={setSnack} />}
            {tab === 1 && <ReferralsManager setSnack={setSnack} />}
          </div>
        </>
      )}
    </div>
  );
};

export default Payments;
